import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/subTasks/importer/subTasksImporterActions'

export default importerReducers(actions)
